import React from 'react';
import { Button } from 'antd';

const StyleTest = () => (
  <div>

    <h1>Heading 1</h1>
    <h2>Heading 2</h2>
    <h3>Heading 3</h3>
    <h4>Heading 4</h4>
    <h5>Heading 5</h5>
    <h6>Heading 6</h6>

    <div className="lead">this is a lead sentence</div>
    <div>this is a regular text</div>

    <Button>Default button</Button>

  </div>
);

export { StyleTest };



// WEBPACK FOOTER //
// ./scripts/presentation/StyleTest.jsx